export default __webpack_public_path__ + "static/media/Manual-10.8103f92b.png";